import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-tools',
  templateUrl: './data-tools.component.html',
  styleUrls: ['./data-tools.component.scss']
})
export class DataToolsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
